interface TableCellEllipsisProps {
    children: React.ReactNode
    title?: string
}

export const TableCellEllipsis = ({ children, title }: TableCellEllipsisProps) => {
    return (
        <div
            className="overflow-hidden text-ellipsis whitespace-nowrap max-w-full"
            title={title || (typeof children === 'string' ? children : undefined)}
        >
            {children}
        </div>
    )
}

